import { useValidAuth } from '~/modules/auth/composables/auth-valid'

export default defineNuxtRouteMiddleware((to) => {
  if (process.server) { return }
  const validAuth = useValidAuth()
  return validAuth.authMiddleware(to)
})
